import { populate } from 'populate';import dragonBones from 'pixi-dragonbones';

const raw = {
  className: 'EventOfferButtonLayout',
  width: 186,
  height: 195,
  x: 50,
  y: 50,
  list: [
    {
      id: 'abadc55e-c53b-4149-b27e-9d3617508113',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 5,
      y: 5,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 93,
        y: 97
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: '5495667f-2cee-47df-bf89-0274c4d1f634',
      type: 'Sprite',
      name: 'icon',
      nameSpace: '',
      className: '',
      x: 5,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'valentines_offer_icon',
      parent: 'abadc55e-c53b-4149-b27e-9d3617508113',
      data: ''
    },
    {
      id: '2518040d-7e0f-4601-b16b-bc4af1fc0a85',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 130,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'offer_icon_timer',
      parent: '5495667f-2cee-47df-bf89-0274c4d1f634',
      data: ''
    },
    {
      id: 'ff1ddd06-dd30-433b-84b5-b8ecf1a67697',
      type: 'Text',
      name: 'timerText',
      nameSpace: '',
      className: '',
      x: 98,
      y: 28,
      anchor: {
        x: 0.5,
        y: 0.625
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '99:99:99:99',
      localize: false,
      maxWidth: 90,
      maxHeight: 28,
      maxFontSize: 33,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'Arial',
        fill: 'black',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '2518040d-7e0f-4601-b16b-bc4af1fc0a85',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class EventOfferButtonLayout {
  static raw = raw;
  root: PIXI.Container
  icon: PIXI.Sprite
  timerText: PIXI.Text

  constructor() {
    populate(this, raw);
  }
}
